import {AuditParamDefinition} from '../../../types/AuditParamDefinition';
import {ParamType} from '../../../types/ParamType';
import {AuditParamType} from '../types/AuditParamType';

export const findByParamType = (
  paramDefinitions: Array<AuditParamDefinition> | undefined | null,
  type: ParamType | AuditParamType
): AuditParamDefinition | undefined =>
  paramDefinitions?.find((paramDefinition) => paramDefinition.type === type);
